module.exports = __webpack_public_path__ + "img/360lion-logo.3ab873c6.png";